import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMainApi } from "../provider/main-api.provider";

const PaymentStatus = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { refresh } = useMainApi();

  const params = new URLSearchParams(search);
  const status = params.get("status");
  const paymentId = params.get("paymentId");
  const reason = params.get("reason");
  const isSuccess = status === "success";

  useEffect(() => {
    refresh({ force: true });
  }, []);

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 420,
          textAlign: "center",
          padding: 4,
          border: "1px solid #2a2f45",
          background: "linear-gradient(149deg, #192247 0%, #210e17 96.86%)",
          color: "#fff",
        }}
      >
        {isSuccess ? (
          <CheckCircleIcon sx={{ fontSize: 80, color: "#4caf50", mb: 2 }} />
        ) : (
          <ErrorIcon sx={{ fontSize: 80, color: "#f44336", mb: 2 }} />
        )}

        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {isSuccess ? "Payment Successful" : "Payment Failed"}
        </Typography>

        {isSuccess ? (
          <>
            <Typography sx={{ color: "#b0b6d1", mb: 2 }}>
              Your subscription has been activated successfully.
            </Typography>

            {paymentId && (
              <Typography sx={{ fontSize: 14, color: "#7c8196", mb: 3 }}>
                Payment ID: {paymentId}
              </Typography>
            )}
          </>
        ) : (
          <>
            <Typography sx={{ color: "#b0b6d1", mb: 2 }}>
              Something went wrong while processing your payment.
            </Typography>

            {reason && (
              <Typography sx={{ fontSize: 14, color: "#ff8a80", mb: 3 }}>
                Reason: {reason}
              </Typography>
            )}
          </>
        )}

        <Button
          fullWidth
          sx={{
            mt: 2,
            padding: "12px",
            border: "1px solid #cfc9ff",
            color: "#fff",
            fontSize: 16,
            borderRadius: 0,
            "&:hover": {
              borderColor: "#b37bff",
              background: "rgba(179,123,255,0.05)",
            },
          }}
          onClick={() =>
            navigate(isSuccess ? "/settings/subscription" : "/plans")
          }
        >
          {isSuccess ? "Go to Subscription" : "Retry Payment"}
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentStatus;
